module.exports = __webpack_public_path__ + "static/john-robbins-blueshirt.5039ff88.jpg";